import { useEffect } from 'react';
import { useParams } from 'react-router';
import { enviarDadosMembros, MensagemRetorno } from '../../api/scmmp';
import FotoMembro from '../../components/Membro/FotoMembro';
import MensagemSincronizacao from '../../components/Sincronizacao/MensagemSincronizacao';
import Alert from '../../components/ui/Alert';
import LoadingSpinner from '../../components/ui/LoadingSpinner';
import { useAppSelector } from '../../hooks/use-app-selector';
import useHttp from '../../hooks/use-http';

const SincronizacaoPage: React.FC = (): React.ReactElement => {
  const { membroId, membroNome } = useParams<{ membroId: string; membroNome: string }>();
  const { token } = useAppSelector((state) => state.auth);

  const {
    sendRequest,
    status,
    error,
    data: mensagens,
  }: { data: MensagemRetorno[]; error: string; status: string; sendRequest: any } = useHttp(
    enviarDadosMembros
  );

  useEffect(() => {
    if (membroId !== undefined) {
      sendRequest({ token, membroId });
    }
  }, [sendRequest, token, membroId]);

  return (
    <div className="container mt-3">
      {status === 'pending' && <h2 className="h2">Enviando dados de {membroNome}...</h2>}
      {status !== 'pending' && !error && mensagens !== null && mensagens.length === 0 && (
        <Alert message="Envio finalizado." type="success" />
      )}
      {status !== 'pending' && !error && mensagens !== null && mensagens.length > 0 && (
        <Alert
          message="Alguns membros não puderam ser atualizados, pelos motivos abaixo."
          type="danger"
        />
      )}
      {error && <Alert message={error} type="danger" />}
      {mensagens === null && !error && <LoadingSpinner />}
      {mensagens !== null && mensagens.length > 0 && (
        <>
          <h3 className="h3">Mensagens de validação:</h3>
          <table className="table table-striped">
            <thead>
              <tr>
                <th></th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Mensagem</th>
              </tr>
            </thead>
            <tbody>
              {mensagens &&
                mensagens.map((mensagem) => (
                  <>
                    <tr>
                      <td>
                        <FotoMembro pessoaFisicaId={mensagem.idPessoaFisica} />
                      </td>
                      <td>{mensagem.servidor}</td>
                      <td>
                        <MensagemSincronizacao tipo={mensagem.tipoMensagem} />
                      </td>
                      <td>{mensagem.texto}</td>
                    </tr>
                  </>
                ))}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
};

export default SincronizacaoPage;
